module.exports = __webpack_public_path__ + "static/media/tick.f7f967c5.svg";